import { useEffect, useRef, useState } from 'react';

export const useAllCheckBtn = ({ toggles, setAllToggle }) => {
  const allCheckBtnRef = useRef(false);

  const handleAgreeAll = () => {
    const on = allCheckBtnRef.current.classList.toggle('on') ? true : null;
    setAllToggle(on);
  };

  useEffect(() => {
    const target = document.querySelector('.btn-agree-all');
    if (!target) return;
    const checkBox = target.querySelector('.chk-type-01');
    allCheckBtnRef.current = checkBox;
  }, []);

  useEffect(() => {
    const agreeAllBtn = document.querySelector('.btn-agree-all');
    if (agreeAllBtn) agreeAllBtn.addEventListener('click', handleAgreeAll);

    return () => {
      if (agreeAllBtn) agreeAllBtn.removeEventListener('click', handleAgreeAll);
    };
  }, [handleAgreeAll]);

  useEffect(() => {
    if (allCheckBtnRef.current) {
      if (allCheckBtnRef.current.classList.contains('on') === toggles.every((item) => item)) return;
      allCheckBtnRef.current.classList.toggle('on');
    }
  }, [toggles]);

  return { handleAgreeAll, allCheckBtnRef };
};
